import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// Swallow the harmless CRA dev-overlay warning:
// "ResizeObserver loop completed with undelivered notifications."
// This is a browser-level noise (fired by Radix/shadcn popovers, selects, etc.)
// that the dev overlay treats as an uncaught error. It never occurs in
// production builds. We intercept it in the capture phase so the overlay
// never sees it.
const IGNORED_MESSAGES = [
  /ResizeObserver loop completed with undelivered notifications/,
  /ResizeObserver loop limit exceeded/,
];

const shouldIgnore = (msg) =>
  IGNORED_MESSAGES.some((re) => re.test(String(msg || "")));

window.addEventListener(
  "error",
  (e) => {
    if (shouldIgnore(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
  },
  true, // capture phase — run before CRA's error overlay handler
);

window.addEventListener("unhandledrejection", (e) => {
  const msg = e?.reason?.message || e?.reason;
  if (shouldIgnore(msg)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
